import React, { FunctionComponent } from "react"
import { useTranslation } from "react-i18next"

import { Flex } from "components/Flex"

import Button, { ButtonTheme } from "components/Button/Button"
import Modal, { IModalProps } from "components/Modal/Modal"

export interface IAlertModalProps extends IModalProps {
    theme?: ButtonTheme
    buttonLabel?: string
}

const AlertModal: FunctionComponent<React.PropsWithChildren<IAlertModalProps>> = ({
    theme = "primary",
    title,
    onClose,
    buttonLabel,
    children,
    ...others
}) => {
    const { t } = useTranslation()

    return (
        <Modal
            title={title}
            onClose={onClose}
            footer={
                <Flex justifyContent="flex-end">
                    <Button
                        theme={theme}
                        label={buttonLabel || t('common.ok')}
                        onClick={onClose}
                    />
                </Flex>
            }
            {...others}>
            {children}
        </Modal>
    )
}

export default AlertModal
